import React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { withStyles } from "@material-ui/core/styles";

import DataTableHead from "./DataTableHead";
import DataTableToolbar from "./DataTableToolbar";

// Material UI
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableFooter from "@material-ui/core/TableFooter";
import TablePagination from "@material-ui/core/TablePagination";
import TableRow from "@material-ui/core/TableRow";
import Paper from "@material-ui/core/Paper";

const styles = theme => ({
  root: {
    width: "100%",
    overflowX: "auto"
  },
  table: {
    minWidth: 500
  }
});

class DataTable extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      page: 0,
      rowsPerPage: 100
    };
  }

  handleChangePage = (event, page) => {
    this.setState({ page });
  };

  handleChangeRowsPerPage = event => {
    this.setState({ rowsPerPage: event.target.value });
  };

  render() {
    const { classes, data, config } = this.props;
    const { page, rowsPerPage } = this.state;
    const { columns, order, orderBy, title } = config;

    return (
      <Paper className={classes.root}>
        <DataTableToolbar title={title}/>
        <Table
          className={classes.table}
          aria-labelledby="tableTitle"
          padding="default"
        >
          <DataTableHead
            data={this.props.data}
            columns={columns}
            order={order}
            orderBy={orderBy}
          />
          <TableBody>
            {data ? (
              data
                .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                .map((dataItem, index) => {
                  return (
                    <TableRow
                      hover
                      tabIndex={-1}
                      key={index}
                    >
                      {columns.map((columnItem, columnIndex) => {
                        return (
                          <TableCell
                            key={columnIndex}
                            padding={columnItem.padding}
                          >
                            {typeof dataItem[columnItem.key] === "number" &&
                            dataItem[columnItem.key] % 1 !== 0
                              ? parseFloat(dataItem[columnItem.key]).toFixed(
                                2
                              )
                              : dataItem[columnItem.key]}
                          </TableCell>
                        );
                      })}
                    </TableRow>
                  );
                })
            ) : (
              <TableRow>No Data To Display</TableRow>
            )}
          </TableBody>
          <TableFooter>
            <TableRow>
              <TablePagination
                className="pagination"
                rowsPerPageOptions={[25, 100, 200]}
                count={data.length}
                page={page}
                rowsPerPage={rowsPerPage}
                onChangePage={this.handleChangePage}
                onChangeRowsPerPage={this.handleChangeRowsPerPage}
              />
            </TableRow>
          </TableFooter>
        </Table>
      </Paper>
    );
  }
}

const mapStateToProps = (state, ownProps) => ({
  batteryInformation: state.battery
});

DataTable.propTypes = {
  classes: PropTypes.object.isRequired,
  data: PropTypes.array.isRequired,
  config: PropTypes.object.isRequired
};

export default withStyles(styles)(
  connect(
    mapStateToProps,
    {}
  )(DataTable)
);



// WEBPACK FOOTER //
// ./src/components/table/DataTable.js